import { createStyles, Theme } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

export const useRatesUnavailableInlineStyles = makeStyles((theme: Theme) =>
  createStyles({
    /** Same family as checkout page `Alert` (address valid / invalid). */
    alert: {
      width: '100%',
      boxSizing: 'border-box',
      alignItems: 'center',
      '& .MuiAlert-message': {
        paddingTop: theme.spacing(0.25),
        paddingBottom: theme.spacing(0.25),
      },
    },
  })
)
